import { adminClient, genericOAuthClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { appRoles } from "./auth-roles";

export const authClient = createAuthClient({
  baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:3000",
  // The SAME declarations the server passes to `admin()`. The client plugin
  // infers the role union it will accept from `keyof roles` independently, so
  // omitting them here left `setRole` typed as "user" | "admin" only and
  // rejected the two new tiers at the call site.
  //
  // `genericOAuthClient` is what exposes `signIn.oauth2`, used by the Microsoft
  // sign-in button. Registering it costs nothing where the server has no
  // provider configured: the call would simply be refused, and the button that
  // makes it is not rendered.
  plugins: [adminClient({ roles: appRoles }), genericOAuthClient()],
});

// No `signUp`: open registration is off (`disableSignUp` in auth.ts) and the
// page that used it is gone. Accounts come from an admin or from Microsoft.
export const { signIn, signOut, useSession } = authClient;
